import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import style from '../css/racersListComplexBets.css';
import ComplexBetGameCard from '../components/complexBetGameCard.js';
import {getText} from '../../../../../helpers/localization';
import {FORECAST, REVERSE_FORECAST, REVERSE_TRICAST, TRICAST} from '../constants/identifiers';
import ToggleButton from '../../../components/toggleButton';
import {sortRacers} from '../helpers/sortingHelper';
import {SORT_BY_NUMBER} from '../constants/sortingTypes';
import {betSlipAnimationCalculate} from "../../../../../helpers/helperFunctions";
import buttonStyle from "../../../css/button.css";
import {ASSETS_URL} from "../../../../../constants/endpoints";

//actions
import {
    clearMultiBetRacerSelection,
    selectRacingBetType,
    toggleRaceCardSortFieldSelection
} from '../actions/raceCardActions';
import {addOpenBet} from '../../../actions/openBetsActions';
import {isMarbleEvent} from '../helpers/racersHelper';

const mapStateToProps = (state, ownProps) => {
    let ret = {
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        selectedRaceCardSortField: state.vpp.selectedRaceCardSortField,
        selectedEventMultiBetList: state.vpp.selectedEventMultiBetList,
        systemLanguage: state.vpp.systemLanguage,
        isBetSlipSideView: state.vpp.isBetSlipSideView,
        showHeader: state.vpp.showHeader,
    };
    return ret;
};

class RacersListComplexBets extends Component {

    constructor(props) {
        super(props);
        this._setBottomButtonStyleWithDelay = this._setBottomButtonStyleWithDelay.bind(this);
        this._setBottomButtonStyle = this._setBottomButtonStyle.bind(this)
        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            selectedRaceCardSortField: storeData.vpp.selectedRaceCardSortField,
            selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList,
            systemLanguage: storeData.vpp.systemLanguage,
            isBetSlipSideView: storeData.vpp.isBetSlipSideView,
            showHeader: storeData.vpp.showHeader,
            isClicked: false,
            animationSourceRect: {
                top: 0,
                left: 0,
            },
        };

    }

    componentDidMount() {
        this._setBottomButtonStyle();


        document.getElementById('bottomContainer').addEventListener('scroll', this._setBottomButtonStyle);
        window.addEventListener('resize', this._setBottomButtonStyleWithDelay);
        window.addEventListener('orientationchange', this._setBottomButtonStyleWithDelay);
    }

    componentWillUnmount() {
        document.getElementById('bottomContainer').removeEventListener('scroll', this._setBottomButtonStyle);
        window.removeEventListener('resize', this._setBottomButtonStyleWithDelay);
        window.removeEventListener('orientationchange', this._setBottomButtonStyleWithDelay);
    }

    componentDidUpdate() {
        this._triggerBottomContainerScrollEvent();
    }

    _triggerBottomContainerScrollEvent() {
        var event = document.createEvent('Event');
        event.initEvent('scroll', true, true);
        let element = document.getElementById('bottomContainer');
        element.dispatchEvent(event);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            let newState = {
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                selectedRacingBetType: storeData.vpp.selectedRacingBetType,
                selectedRaceCardSortField: storeData.vpp.selectedRaceCardSortField,
                selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList,
                systemLanguage: storeData.vpp.systemLanguage,
                isBetSlipSideView: storeData.vpp.isBetSlipSideView,
                showHeader: storeData.vpp.showHeader,
            };
            this.setState(newState);
        }
    }

    _setBottomButtonStyle() {
        /* Emulate a sticky bottom buttons bar by using an additional , fixed positioned buttons bar, so that, only one is made visible at a given time.
        Once a fixed buttons bar rolls over the other, their visibilities are interchanged.*/
        let bottomButtonsBar = document.getElementById('bottomButtonsBar')

        if (this.state.isBetSlipSideView) {
            let isLandscape = window.orientation === 90 ? true : false;
            let bottomButtonsBarFixed = document.getElementById('bottomButtonsBarFixed')
            let placeBetsButtonFixed = document.getElementById('complex_place_bet_fixed')
            let clearSelectionsButtonFixed = document.getElementById('clear_selection_fixed')

            if (bottomButtonsBar && bottomButtonsBarFixed) {
                let buttonsXposition = document.getElementById('clear_selection').getBoundingClientRect().x
                let placeBetsButtonX = document.getElementById('complex_place_bet').getBoundingClientRect().x
                let cardWidth = document.getElementById('racing_card').getBoundingClientRect().width;
                let buttonsBarWidth = 111;
                let buttonsMargin = 10
                let placeBetsButtonFixedLeft = placeBetsButtonX
                let clearSelectionsButtonFixedLeft = placeBetsButtonX - buttonsBarWidth - buttonsMargin
                //let clearSelectionsButtonFixedLeft = cardWidth - 2*buttonsBarWidth - buttonsMargin

                let bottomButtonsBarHeight = bottomButtonsBar.getBoundingClientRect().y
                let fixedBottomButtonsHeight = placeBetsButtonFixed.getBoundingClientRect().y

                if (bottomButtonsBarHeight < fixedBottomButtonsHeight) {
                    bottomButtonsBar.style["visibility"] = "visible";
                    bottomButtonsBar.style["position"] = "relative";
                    placeBetsButtonFixed.style["visibility"] = "hidden";
                    clearSelectionsButtonFixed.style["visibility"] = "hidden";
                } else {
                    bottomButtonsBar.style["visibility"] = "hidden";
                    placeBetsButtonFixed.style["visibility"] = "visible";
                    clearSelectionsButtonFixed.style["visibility"] = "visible";
                    placeBetsButtonFixed.style["position"] = "fixed";
                    clearSelectionsButtonFixed.style["position"] = "fixed";
                    placeBetsButtonFixed.style["left"] = placeBetsButtonFixedLeft + "px";
                    clearSelectionsButtonFixed.style["left"] = clearSelectionsButtonFixedLeft + "px";

                }
            }
        } else {
            bottomButtonsBar.style["position"] = "sticky";
            bottomButtonsBar.style["visibility"] = "hidden";
        }

    }

    _setBottomButtonStyleWithDelay() {
        setTimeout(() => {
            this._setBottomButtonStyle()
        }, 300);
    }


    render() {

        let clearSelectionStyle = this._showClearSelectionButton() ? style.visible : style.hidden
        let clearSelectionButton = (<div id={'clear_selection'}
                                         className={`${style.clearSelectionButton} ${clearSelectionStyle}`}
                                         onClick={() => this._clearSelection()}>{getText('CLEAR_SELECTIONS', this.props.store)}</div>)

        let placeBetButton = (this._isValidToPlace()
            ? <div id={'complex_place_bet'} className={style.placeBetButton}
                   onClick={() => this._addSelectionToBetSlip('complex_place_bet')}>{getText('ADD_TO_BET_SLIP', this.props.store)}</div>
            : <div id={'complex_place_bet'}
                   className={`${style.placeBetButton} ${style.disabled}`}>{getText('ADD_TO_BET_SLIP', this.props.store)}
                {this.state.isClicked && (<div className={`${buttonStyle.betSlipAnimation}`} style={{
                    top: `${this.state.animationSourceRect.top}px`,
                    left: `${(this.state.animationSourceRect.left)}px`
                }}>
                    <img id='bet_slip_animation_image' src={`${ASSETS_URL}systemIcons/betslip.svg`} width="35"
                         height="35"/>
                </div>)}</div>)

        let clearSelectionButtonFixed = (<div id={'clear_selection_fixed'}
                                              className={`${style.clearSelectionButtonFixed} ${clearSelectionStyle}`}
                                              onClick={() => this._clearSelection()}>{getText('CLEAR_SELECTIONS', this.props.store)}</div>)
        let placeBetButtonFixed = (this._isValidToPlace()
            ? <div id={'complex_place_bet_fixed'} className={style.placeBetButtonFixed}
                   onClick={() => this._addSelectionToBetSlip('complex_place_bet_fixed')}>{getText('ADD_TO_BET_SLIP', this.props.store)}</div>
            : <div id={'complex_place_bet_fixed'}
                   className={`${style.placeBetButtonFixed} ${style.disabled}`}>{getText('ADD_TO_BET_SLIP', this.props.store)}
                {this.state.isClicked && (<div className={`${buttonStyle.betSlipAnimation}`} style={{
                    top: `${this.state.animationSourceRect.top}px`,
                    left: `${(this.state.animationSourceRect.left)}px`
                }}>
                    <img id='bet_slip_animation_image' src={`${ASSETS_URL}systemIcons/betslip.svg`} width="35"
                         height="35"/>
                </div>)}</div>)

        let bottomButtons = (<Fragment> {clearSelectionButton} {placeBetButton} </Fragment>)
        let bottomButtonsFixed = (<Fragment> {clearSelectionButtonFixed} {placeBetButton} </Fragment>)
        return (
            <Fragment>
                <div className={style.sortingButtonContainer}>
                    <div className={style.sortingContainer}>
                        {!isMarbleEvent(this.state.events[this.state.selectedEventIndex].eventType) ? (<Fragment>
                            <ToggleButton
                                htmlId='sortRacersToggleButton'
                                style={style.toggleNumber}
                                isChecked={this.state.selectedRaceCardSortField === SORT_BY_NUMBER}
                                callback={() => this.props.store.dispatch(toggleRaceCardSortFieldSelection())}
                                leftText={getText('ODDS', this.props.store)}
                                rightText={getText('NUMBER', this.props.store)}/></Fragment>) : ''}
                    </div>
                    <div className={style.toggleButtonWrapper}>
                        <ToggleButton
                            htmlId='complexBetTypeToggleButton'
                            style={style.toggle}
                            isChecked={this.state.selectedRacingBetType === TRICAST}
                            callback={() => this._toogleBetType()}
                            leftText={isMarbleEvent(this.state.events[this.state.selectedEventIndex].eventType) ? getText('FORECAST_MARBLE', this.props.store) : getText('FORECAST', this.props.store)}
                            rightText={isMarbleEvent(this.state.events[this.state.selectedEventIndex].eventType) ? getText('TRICAST_MARBLE', this.props.store) : getText('TRICAST', this.props.store)}/>
                    </div>
                </div>
                {this._getListOfComplexBetsCardsUI()}
                <div id={'bottomButtonsBar'} className={`${style.bottomButtonsBar}`}>
                    {bottomButtons}
                </div>
                <div id={'bottomButtonsBarFixed'} className={style.bottomButtonsBarFixed}>
                    {clearSelectionButtonFixed}{placeBetButtonFixed}
                </div>
            </Fragment>
        );
    }

    _getListOfComplexBetsCardsUI() {
        let listOfComplexBetsCardsUI = [];
        if (this.state.events.length > 0) {
            let listOfComplexBetsCards = this.state.events[this.state.selectedEventIndex].racers.sort(sortRacers.bind(this.state));
            listOfComplexBetsCardsUI = listOfComplexBetsCards.map((racer, index) => {
                return (
                    <ComplexBetGameCard
                        key={index}
                        index={index}
                        racer={racer}
                        store={this.props.store}
                        selectedRacingBetType={this.state.selectedRacingBetType}
                        isLast={index === (listOfComplexBetsCards.length - 1)}/>
                );
            });
        }
        return listOfComplexBetsCardsUI;
    }

    _toogleBetType() {
        let betType;
        if (this.state.selectedRacingBetType === FORECAST) {
            betType = TRICAST;

        } else {
            betType = FORECAST;

            let selectionAnyArray = this.state.selectedEventMultiBetList[3];
            if (selectionAnyArray.length > 2) {
                this._clearSelection();
            }
        }

        this.props.store.dispatch(selectRacingBetType(betType));

    }

    _isValidToPlace() {
        let auxList = this.state.selectedEventMultiBetList;
        if (this.state.selectedRacingBetType === FORECAST && ((auxList[0] !== undefined && auxList[1] !== undefined && auxList[2] === undefined && auxList[3].length === 0) || (auxList[0] === undefined && auxList[1] === undefined && auxList[2] === undefined && auxList[3].length >= 2))) {
            return true;
        }
        if (this.state.selectedRacingBetType === TRICAST && ((auxList[0] !== undefined && auxList[1] !== undefined && auxList[2] !== undefined && auxList[3].length === 0) || (auxList[0] === undefined && auxList[1] === undefined && auxList[2] === undefined && auxList[3].length >= 3))) {
            return true;
        }

        return false;
    }

    _showClearSelectionButton() {
        let auxList = this.state.selectedEventMultiBetList;
        if (auxList[0] !== undefined || auxList[1] !== undefined || auxList[2] !== undefined || (auxList[3] !== undefined && auxList[3].length > 0)) {
            return true;
        }
        return false;
    }

    _clearSelection() {
        this.props.store.dispatch(clearMultiBetRacerSelection());
    }

    _addSelectionToBetSlip(id) {
        let racers;
        let betType = this.state.selectedRacingBetType;
        let auxList = this.state.selectedEventMultiBetList;
        let marketNum = '';
        let marketId = '';

        if (auxList[3].length > 0) {
            racers = auxList[3].slice();
            // sort racers ascending since rever tricast and forecast odds are the same independently of the order given since event
            // pricelist only includes one of the combinations and it is the ascending one
            racers = racers.sort((a, b) => a.num - b.num);
            if (betType === FORECAST) {
                betType = REVERSE_FORECAST;

                let marketIdAux = [
                    auxList[3][0].num,
                    auxList[3][1].num
                ];
                marketIdAux = marketIdAux.sort((a, b) => a - b);

                marketId = REVERSE_FORECAST.code + '_' + marketIdAux[0] + '-' + marketIdAux[1];
                marketNum = marketIdAux[0] + '-' + marketIdAux[1];
            } else {
                betType = REVERSE_TRICAST;

                let marketIdAux = [
                    auxList[3][0].num,
                    auxList[3][1].num,
                    auxList[3][2].num
                ];
                marketIdAux = marketIdAux.sort((a, b) => a - b);

                marketId = REVERSE_TRICAST.code + '_' + marketIdAux[0] + '-' + marketIdAux[1] + '-' + marketIdAux[2];
                marketNum = marketIdAux[0] + '-' + marketIdAux[1] + '-' + marketIdAux[2];
            }
        } else if (betType === FORECAST && auxList[0] !== undefined && auxList[1] !== undefined && auxList[2] === undefined) {
            racers = [
                auxList[0], auxList[1]
            ];
            marketId = FORECAST.code + '_' + auxList[0].num + '-' + auxList[1].num;
            marketNum = auxList[0].num + '-' + auxList[1].num;
        } else if (betType === TRICAST && auxList[0] !== undefined && auxList[1] !== undefined && auxList[2] !== undefined) {
            racers = [
                auxList[0], auxList[1], auxList[2]
            ];
            marketId = TRICAST.code + '_' + auxList[0].num + '-' + auxList[1].num + '-' + auxList[2].num;
            marketNum = auxList[0].num + '-' + auxList[1].num + '-' + auxList[2].num;
        }

        let bet = {
            game: this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex],
            event: this.props.store.getState().vpp.events[this.props.store.getState().vpp.selectedEventIndex],
            betType: betType,
            market: {
                id: marketId,
                num: marketNum
            },
            racers: racers
        };

        this.props.store.dispatch(addOpenBet(bet, this.props.store.getState().vpp.openBetsList));
        this._updateStateForAnimation(id);
    }

    _updateStateForAnimation(id) {
        let sourceRectValues = betSlipAnimationCalculate(false, document.getElementById(id));
        clearTimeout(this.handle);

        this.setState({
            ...this.state,
            isClicked: true,
            animationSourceRect: {
                top: sourceRectValues.sourceTop,
                left: sourceRectValues.sourceLeft,
            }
        })
        this.handle = setTimeout(() => {
            this.setState({
                ...this.state,
                isClicked: false
            })
        }, 1000);
    }

}

export default connect(mapStateToProps)(RacersListComplexBets);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/containers/racersListComplexBets.js